import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { useRouteParams } from '../useRouteParams';

export function useNavigateToDate() {
  const navigate = useNavigate();
  const { routeParams, searchParams } = useRouteParams();

  function navigateToCurrentMonth() {
    const currentDate = dayjs();
    navigate(
      `/controlling/umsatzplanung/${routeParams.jahr}/${
        routeParams.monat
      }/ziele/edit?jahr=${dayjs(currentDate).get('year')}&monat=${
        dayjs(currentDate).get('month') + 1
      }`,
    );
  }

  function navigateToPrevMonth() {
    const prevDate = dayjs(
      `${searchParams.jahr}-${searchParams.monat}-01`,
    ).subtract(1, 'month');

    navigate(
      `/controlling/umsatzplanung/${routeParams.jahr}/${
        routeParams.monat
      }/ziele/edit?jahr=${dayjs(prevDate).get('year')}&monat=${
        dayjs(prevDate).get('month') + 1
      }`,
    );
  }

  function navigateToNextMonth() {
    const nextDate = dayjs(`${searchParams.jahr}-${searchParams.monat}-01`).add(
      1,
      'month',
    );

    navigate(
      `/controlling/umsatzplanung/${routeParams.jahr}/${
        routeParams.monat
      }/ziele/edit?jahr=${dayjs(nextDate).get('year')}&monat=${
        dayjs(nextDate).get('month') + 1
      }`,
    );
  }

  return {
    navigateToPrevMonth,
    navigateToCurrentMonth,
    navigateToNextMonth,
  };
}
